import React, { FC } from 'react';
import NCFileCentralPart from '@components/operatorPanel/components/elements/NCFileCentralPart';
import { MachineStatus } from '@interfaces/machines';
import { ncFileStatuses, subStatuses } from '@helpers';
import Counter from '@components/operatorPanel/components/elements/Counter';
import MachineRunningNoNCFileCentralPart from '@components/operatorPanel/components/elements/MachineRunningNoNCFileCentralPart';
import { font as initialFont } from '@styles/fonts';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface HomePageCentralPartProps
  extends Pick<PanelProps, 'CC' | 'bgColor' | 'count' | 'maxCount' | 'isOperator' | 'scale' | 'font' | 'correctQuantity' | 'productionBatchId'> {
  ncFileId: number;
  ncFileName: string;
  machineStatus: MachineStatus;
  isWithERP: boolean | null;
}

const HomePageCentralPart: FC<HomePageCentralPartProps> = ({
  CC,
  ncFileId,
  machineStatus,
  bgColor,
  count,
  maxCount,
  ncFileName,
  scale,
  isOperator = true,
  font = initialFont,
  correctQuantity,
  productionBatchId,
}) => {
  const ncFileChange = machineStatus.ncFileStatus === ncFileStatuses.Change;
  const ncFileIgnored = machineStatus.ncFileStatus === ncFileStatuses.Ignored;
  const ncFileSetup = machineStatus.ncFileStatus === ncFileStatuses.Setup;

  const shouldDisplaySimpleMachineInfo = machineStatus.subStatus === subStatuses.Running && !ncFileName;

  const shouldDisplayNCFileInfo = ncFileChange || ncFileIgnored || ncFileSetup;

  if (shouldDisplaySimpleMachineInfo) {
    return (
      <MachineRunningNoNCFileCentralPart
        CC={CC}
        executionMode={machineStatus.executionMode}
        lastUpdatedOn={machineStatus.lastUpdatedOn}
        scale={scale}
        font={font}
      />
    );
  }

  if (shouldDisplayNCFileInfo) {
    return (
      <NCFileCentralPart
        CC={CC}
        ncFileId={ncFileId}
        machineStatus={machineStatus}
        ncFileChange={ncFileChange}
        ncFileSetup={ncFileSetup}
        isOperator={isOperator}
        scale={scale}
        font={font}
        productionBatchId={productionBatchId}
      />
    );
  }

  return (
    <Counter
      {...{
        CC,
        bgColor,
        count,
        machineStatus: machineStatus.status,
        ncFileStatus: machineStatus.ncFileStatus,
        isOperator,
        targetCount: maxCount,
        onMinusButtonPress: () => correctQuantity(-1),
        onPlusButtonPress: () => correctQuantity(+1),
        scale,
        font,
      }}
    />
  );
};

export default HomePageCentralPart;
